# ------------------------------------*|
# #Editor Layout -> Animations
# ------------------------------------*|

moduleAnim = angular.module 'services.animations', []
moduleAnim.factory 'Animation', ["$timeout", ($timeout) ->
  animations =
    prepareSlideDown: (node) ->
      $(node._node).slideUp(0)
    slideUp: (node) ->
      $(node._node).slideUp(200)
    slideDown: (node) ->
      $(node._node).slideDown(200)
    scrollTo: (node) ->
      $('html,body').animate
        scrollTop: node.offset().top-32
      , 500
      return
  animations
]



// WEBPACK FOOTER //
// ./src/app/editor/services/layout_editor/animations.coffee